import { createNavigation } from 'next-intl/navigation'
import { defineRouting } from 'next-intl/routing'

export const routing = defineRouting({
  locales: ['en-US', 'es-AR', 'fr-FR', 'ko-KR', 'zh-CN'],
  defaultLocale: 'en-US',
  localeDetection: false,
  localePrefix: {
    mode: 'always',
    prefixes: {
      'en-US': '/en',
      'es-AR': '/es',
      'fr-FR': '/fr',
      'ko-KR': '/ko',
      'zh-CN': '/zh',
    },
  },
})

export const { Link, redirect, usePathname, useRouter, getPathname } =
  createNavigation(routing)
